// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import  'lib-flexible/flexible'
import Vant from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css';
import vueSeamlessScroll from 'vue-seamless-scroll';
import Moment from 'moment';
import vueTouch from 'kim-vue-touch'
//中文引入
import 'moment/locale/zh-cn'

// 定义全局时间戳过滤器
Vue.filter('formatDate', function(value) {
  //return Moment(value).format('YYYY-MM-DD HH:mm:ss')
  return  Moment(value).calendar();
  //return Moment(value).startOf('hour').fromNow();
})

Vue.use(vueTouch)
Vue.use(Vant);
Vue.use(vueSeamlessScroll);
Vue.use(ElementUI);
// 完整加载
// import LuckDraw from 'vue-luck-draw'
// Vue.use(LuckDraw)

// 按需引入
// import { LuckyWheel, LuckyGrid } from 'vue-luck-draw'
// Vue.components('LuckyWheel', LuckyWheel)
// Vue.components('LuckyGrid', LuckyGrid)

Vue.config.productionTip = false


// 屏幕自适应穿透px为rem模板
const baseSize = 37.5; // 设计稿根字体大小
function setRem() {
  if (
    document.documentElement.clientWidth >= 762 &&
    document.documentElement.clientWidth <= 4000
  ) {
    const scale = document.documentElement.clientWidth / 1920; // 计算缩放比例
    document.documentElement.style.fontSize =
      baseSize * Math.min(scale, 2) + "px"; // 设置根字体大小
  }
  // if (
  //   document.documentElement.clientWidth >= 300 &&
  //   document.documentElement.clientWidth <= 762
  // ) {
  //   // const scale = (750) / 1920 // 计算缩放比例
  //   document.documentElement.style.fontSize = 62.5 + "%"; // 设置根字体大小
  //   // document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
  // }
  console.log(document.documentElement.style.fontSize)
}

setRem();

window.addEventListener("resize", setRem); // 窗口大小改变时重新计算


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js